import TIMELINE from 'core/gd/const/modules/timeline';

const DEFAULT_ATTACHMENTS = true;
const DEFAULT_WORKLOAD = {
    summaryMode     : TIMELINE.summaryMode.HOURS,
    allocationType  : TIMELINE.timeAllocation.autoDistributionType.FRONT_LOAD,
    allocationMode  : TIMELINE.timeAllocation.distributionMode.AUTO
}

const DEFAULT_CRM_CONTACT = {
    customFields: [],
    glist: {
        columns: null,
        groupBy: null
    },
    contactTypes:   [
        {value: '1',   label: 'Lead',       color: 11},
        {value: '2',   label: 'Sales',      color: 3},
        {value: '3',   label: 'Customer',   color: 22},
    ]
}

const DEFAULT_CRM_ACCOUNT = {
    customFields: [],
    glist: {
        columns: null,
        groupBy: null
    }
}

const DEFAULT_COMPANY_USERS = {
    customFields: []
}

const DEFAULT_SKILLS = {
    options: []
}

const DEFAULT_FORMS = {
    enabled: true
}

// const DEFAULT_EMAIL_NOTIFICATION_3RD_PARTY = {
//     enabled: true
// }

// we need to use SettingsProto in future i think ....

export default class CompanySettingsModules {

    constructor(modulesConfig) {
        this._init(modulesConfig);
    }

    _init(data) {
        // If false it will disable ALL attachments including GDrive & "Files" view
        this.attachments        = _.get(data, 'attachments', DEFAULT_ATTACHMENTS);

        this.workload           = {
            summaryMode:    _.get(data, 'workload.summaryMode', DEFAULT_WORKLOAD.summaryMode),
            allocationType: _.get(data, 'workload.allocationType', DEFAULT_WORKLOAD.allocationType),
            allocationMode: _.get(data, 'workload.allocationMode', DEFAULT_WORKLOAD.allocationMode)
        };

        this.crmContact         = this._initCrmContact(_.get(data, 'crmContact', {}))
        this.crmAccount         = this._initCrmAccount(_.get(data, 'crmAccount', {}))

        // this is a setting that allow sending email notification to crm contacts or other users via email from gooday when
        // reply task or similar
        this.contactsEmailNotification  = this._initEmailNotification3rdParty(_.get(data, 'contactsEmailNotification', {}))

        this.companyUsers       = this._initCompanyUsers(_.get(data, 'companyUsers', {}))
        this.skills             = this._initSkills(_.get(data, 'skills', {}))

        this.forms              = this._initForms(_.get(data, 'forms', {}))
    }

    _initCrmContact(crmContact) {
        return {
            customFields    : _.get(crmContact, 'customFields', _.cloneDeep(DEFAULT_CRM_CONTACT.customFields)), //cloneDeep is required in order not to rewrite DEFAULT_CRM_CONTACT values
            glist           : _.get(crmContact, 'glist', _.cloneDeep(DEFAULT_CRM_CONTACT.glist)), //cloneDeep is required in order not to rewrite DEFAULT_CRM_CONTACT values
            contactTypes    : _.get(crmContact, 'contactTypes', _.cloneDeep(DEFAULT_CRM_CONTACT.contactTypes)), //cloneDeep is required in order not to rewrite DEFAULT_CRM_CONTACT values
        }
    }

    _initCrmAccount(crmAccount) {
        return {
            customFields    : _.get(crmAccount, 'customFields', _.cloneDeep(DEFAULT_CRM_ACCOUNT.customFields)), //cloneDeep is required in order not to rewrite DEFAULT_CRM_ACCOUNT values
            glist           : _.get(crmAccount, 'glist', _.cloneDeep(DEFAULT_CRM_ACCOUNT.glist)), //cloneDeep is required in order not to rewrite DEFAULT_CRM_ACCOUNT values
        }
    }

    _initEmailNotification3rdParty() {

        const isEnabled = _.includes(['U48GJt','89d5pB'], gd.companyId )

        return {
            enabled: isEnabled
        }
    }

    _initCompanyUsers(companyUsers) {
        return {
            customFields: _.get(companyUsers, 'customFields', _.cloneDeep(DEFAULT_COMPANY_USERS.customFields)), //cloneDeep is required in order not to rewrite DEFAULT_COMPANY_USERS values
        }
    }

    _initSkills(skills) {
        return {
            options: _.get(skills, 'options', _.cloneDeep(DEFAULT_SKILLS.options)), //cloneDeep is required in order not to rewrite DEFAULT_SKILLS values
        }
    }

    _initForms(requests) {
        return {
            enabled: _.get(requests, 'enabled', _.cloneDeep(DEFAULT_FORMS.enabled))
        }
    }
    toJSON() {
        const result = {};

        if (!_.isEqual(this.attachments,DEFAULT_ATTACHMENTS))               result.attachments      = this.attachments
        if (!_.isEqual(this.workload, DEFAULT_WORKLOAD))                    result.workload         = this.workload
        if (!_.isEqual(this.crmContact, DEFAULT_CRM_CONTACT))               result.crmContact       = this.crmContact
        if (!_.isEqual(this.crmAccount, DEFAULT_CRM_ACCOUNT))               result.crmAccount       = this.crmAccount
        if (!_.isEqual(this.companyUsers, DEFAULT_COMPANY_USERS))           result.companyUsers     = this.companyUsers
        if (!_.isEqual(this.skills, DEFAULT_SKILLS))                        result.skills           = this.skills
        if (!_.isEqual(this.forms, DEFAULT_FORMS))                          result.forms            = this.forms

        return result;
    }
}
